// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"5ae4054f","311":"4823d14f","438":"bc110609","606":"5cc9fc20","624":"3a4293c5","659":"5ff59b93"}[chunkId] + ".chunk.js";
};